// Timeline (activity-stream) helpers for pinned-lead verbs.
//
// The backend emits `lead_pinned`, `lead_pin_updated` and `lead_unpinned`
// actions with the pin note in the action's data. ActstreamActionSerializer
// nests extra data one level down (`act.data.data.*`, as every other verb on
// the Timeline reads it); the flat `act.data.reason` shape is accepted too so
// a serializer tweak doesn't silently drop the note.

export const LEAD_PIN_VERBS = ['lead_pinned', 'lead_pin_updated', 'lead_unpinned'];

export const LEAD_PIN_VERB_CONFIG = {
    lead_pinned: { icon: 'mdi:pin', color: '#078DEE' },
    lead_pin_updated: { icon: 'mdi:pencil', color: '#078DEE' },
    lead_unpinned: { icon: 'mdi:pin-off', color: '#919EAB' },
};

const LEAD_PIN_VERB_TEXT = {
    lead_pinned: 'Lead pinned',
    lead_pin_updated: 'Pin note updated',
    lead_unpinned: 'Lead unpinned',
};

export const isLeadPinActivity = (act) => LEAD_PIN_VERBS.includes(act?.verb);

const actorDisplayName = (actor) => {
    if (!actor) return '';
    const full = `${actor.first_name || ''} ${actor.last_name || ''}`.trim();
    return full || actor.username || '';
};

// "Lead pinned by Jane Smith" — or just "Lead pinned" when there is no actor.
export const leadPinActivityTitle = (act) => {
    const base = LEAD_PIN_VERB_TEXT[act?.verb];
    if (!base) return '';
    const name = actorDisplayName(act?.actor);
    return name ? `${base} by ${name}` : base;
};

export const leadPinActivityReason = (act) => {
    if (!isLeadPinActivity(act)) return '';
    const d = act?.data;
    const raw = d?.data?.reason ?? d?.reason ?? act?.action_object?.reason;
    return typeof raw === 'string' ? raw.trim() : '';
};
